import React, { useState, useEffect } from "react"
import { getOptionsForDropDownIfDataElementConfiguredWithData, ChipSelect } from 'dsilo-ui-components'
import SimpleSelect from "../SimpleSelect";

const CustomSelectField = (props) => {
    const { classes, className, element, dataObj, options, onChange, isLoading, commonMasterDataFullDropDownKeys, fullDropDownFetchedList, selectedStep, masterDataStoreObject, membersList } = props

    const { chartUniqueId } = props.data
    let key = element.name || element.value
    function getValueByPath(obj, path) {
        return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    }

    let rawValue = getValueByPath(dataObj, key);
    let value;

    if (typeof rawValue === 'string') {
        value = { value: rawValue, label: rawValue };
    }
    else {
        value = rawValue;
    }
    let variant = 'fixed';
    const [filteredMembers, setFilteredMembers] = useState(membersList);
    if (element.type === 'namepicker' && element?.data?.type === 'members' && value) {
        value = {
            value: value.name,
            label: value.name
        }
    }
    if (element.type === 'namepicker' && element?.data?.type === 'roles' && value) {
        value = {
            value: value.value,
            label: value.value
        }
    }
    useEffect(() => {
        if (element?.data?.type === 'members' && element.conditions) {
            let filteredList = Array.isArray(membersList) ? [...membersList] : [];
            element.conditions.forEach((res) => {
                if (res.selectedConditionDataElement && res.value) {
                    filteredList = filteredList.filter((dat) => {
                        const fieldValue = dat[res.selectedConditionDataElement];
                        return typeof fieldValue === 'string' ? !fieldValue.includes(res.value) : true;
                    });
                }
            });
            setFilteredMembers(filteredList);
        } else {
            setFilteredMembers(membersList);
        }
    }, [element, membersList]);

    const getOptions = (eachField, rowIndex, commonMasterDataFullDropDownKeys, currentValue) => {
        return getOptionsForDropDownIfDataElementConfiguredWithData(eachField, masterDataStoreObject,
            chartUniqueId, fullDropDownFetchedList, rowIndex, false, commonMasterDataFullDropDownKeys, eachField?.data?.variant, currentValue, { members: filteredMembers })
    }
    // return (
    //     <ChipSelect
    //         id={`${key}`}
    //         isSearchable
    //         value={value}
    //         placeholder=''
    //         isClearable={true}
    //         menuPlacement='top'
    //         isDisabled={element.readOnly}
    //         options={options ? options : getOptions(element, dataObj.guId, commonMasterDataFullDropDownKeys, value?.value)}
    //         className={classes.selectField}
    //         textFieldProps={{
    //             InputLabelProps: {
    //                 shrink: true
    //             },
    //             variant: "outlined",
    //             disabled: element.readonly
    //         }}
    //         variant={variant}
    //         onChange={(v) => { onChange(key, v?.value, undefined, 'select', element, v) }}
    //         isLoading={isLoading}
    //     />

        
    // )
    return (
        <SimpleSelect
            id={`${key}`}
            isSearchable
            value={value ?? null}
            placeholder="Select an option"
            isClearable
            menuPlacement="top"
            isDisabled={element.readOnly}
            options={
                options
                    ? options
                    : getOptions(
                        element,
                        dataObj.guId,
                        commonMasterDataFullDropDownKeys,
                        value?.value
                    )
            }
            className={classes?.selectField}
            onChange={(v) => {
                onChange(key, v?.value, undefined, "select", element, v);
            }}
            isLoading={isLoading}
            onMenuOpen={() => {
                console.log("Menu opened");
            }}
          
        />
    )
}

export default CustomSelectField